import { createFileRoute } from '@tanstack/react-router';
import { GettingStartedPage } from '@/pages/dashboard/getting-started/GettingStartedPage';

export const Route = createFileRoute('/_authenticated/_app/getting-started')({
	component: GettingStartedPage,
});
